/**
 * Supabase Client Configuration
 * ==============================
 * Single source of truth for Supabase connection.
 * 
 * NO CUSTOM LOCK LOGIC - Use Supabase native auth handling.
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Check if Supabase is configured
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// Create client with STANDARD configuration
// NO custom lock, NO custom storage adapters
export const supabase = isSupabaseConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    })
  : null;

export default supabase;
